var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAddressDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18,
    viewBox: "0 0 18.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_addresss_documents",
    d: "M326.323,701.622h3.449l-3.985-3.91v3.382A.534.534,0,0,0,326.323,701.622Zm-3.612,5.574a5.315,5.315,0,0,0-10.628,0c0,1.4.862,3.19,2.563,5.329a28.6,28.6,0,0,0,2.526,2.775.33.33,0,0,0,.449,0,28.6,28.6,0,0,0,2.526-2.775C321.848,710.386,322.711,708.593,322.711,707.2Zm-5.339,2.893a2.885,2.885,0,1,1,2.939-2.884A2.887,2.887,0,0,1,317.372,710.089Zm8.951-7.413a1.6,1.6,0,0,1-1.612-1.582V697.4h-6.987a1.6,1.6,0,0,0-1.612,1.582V700.1a7.306,7.306,0,0,1,8.185,4.721h2.027a.528.528,0,1,1,.047,1.055h-1.787a7.168,7.168,0,0,1,.115,1.054h1.625a.528.528,0,1,1,.047,1.055h-1.719a7.188,7.188,0,0,1-.239,1.055h1.91a.527.527,0,1,1,.006,1.054h-2.3c-.151.343-.324.694-.525,1.055h2.807a.528.528,0,0,1,.092,1.052l-.045,0h-3.5c-.336.506-.708,1.025-1.137,1.565-.446.56-.918,1.1-1.4,1.634h8.156a1.6,1.6,0,0,0,1.612-1.582V702.676Z",
    transform: "translate(-312.083 -697.403)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAddressDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_address_documents.32bd870056568b9cecaa106edb88ac35.svg";